import MasterLayout from "@/layouts/master";
export default [
	{
    path: "/paciente",
    component: MasterLayout,
    children: [
      {
        path: "agendar",
        name: "paciente.agendar",
        component: () => import("@/views/paciente/agendar/index.vue")
      },
      {
        path: "pacientes",
        name: "paciente.pacientes",
        component: () => import("@/views/paciente/pacientes/index.vue")
      },
      {
        path: "agenda",
        name: "paciente.agenda",
        component: () => import("@/views/paciente/agenda/index.vue")
      },
      {
        path: "registrar",
        name: "paciente.registrar",
        component: () => import("@/views/paciente/registrar/index.vue")
      },
      {
        path: "garantias",
        name: "paciente.garantias",
        component: () => import("@/views/paciente/garantias/index.vue")
      },
      {
        path: "historial",
        name: "paciente.historial",
        component: () => import("@/views/paciente/historial/index.vue")
      }
    ]
  }
]